import { en } from './en';
import { de } from './de';
import { fr } from './fr';

export const messages = {
    'en-US': en,
    'de-DE': de,
    'fr-FR': fr,
};
